import { Component, Input, OnInit } from '@angular/core';
import { PropertyFormService } from '../../services/property-form.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { Country } from '../../../../../shared/address/Country';
import { State } from '../../../../../shared/address/State';

@Component({
  selector: 'property-form-address',
  templateUrl: './property-form-address.component.html',
  styleUrls: ['./property-form-address.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIcon,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatOption,
    MatSelectModule,
    MatInputModule
  ]
})
export class PropertyFormAddressComponent implements OnInit {

  @Input() propertyFormService!: PropertyFormService;

  form!: FormGroup;
  countries!: Country[];
  states!: State[];

  panelOpen: boolean = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.propertyFormService.countries$.subscribe(countries => this.countries = countries);
    this.propertyFormService.states$.subscribe(states => this.states = states);

    this.form = this.formBuilder.group({
      address_id: [],
      country_id: [1, Validators.required],
      country_name: ['', Validators.pattern(/[\S]/)],
      city: ['', [Validators.required, Validators.pattern(/[\S]/)]],
      state: ['', Validators.required],
      address_line_1: ['', [Validators.required, Validators.pattern(/[\S]/)]],
      address_line_2: ['', Validators.pattern(/[\S]/)],
      postal_code: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
    });

    this.propertyFormService.existingPropertyLoaded$.subscribe(state => {
      if(!state) {
        return;
      }

      this.form.patchValue({
        address_id: state.propertyAddressId,
        country_id: state.propertyAddressCountryId,
        country_name: state.propertyAddressCountryName,
        city: state.propertyAddressCity,
        state: state.propertyAddressState,
        address_line_1: state.propertyAddressLine1,
        address_line_2: state.propertyAddressLine2,
        postal_code: state.propertyAddressPostalCode
      });

      this.form.markAllAsTouched();
      this.form.markAsDirty();
      this.updateStateAndFormValidity(this.form.value);
    });

    this.form.valueChanges.subscribe(state => this.updateStateAndFormValidity(state));
  }

  private updateStateAndFormValidity(state: any) {
    this.propertyFormService.updatePropertyAddressState(state);
    this.updateStepValidity();
  }

  private updateStepValidity() {
    this.propertyFormService.setAddressStepValidity(this.form.valid);
  }
}